export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s wurde nicht ausgewählt';
                break;

            case 'firstname':
            case 'lastname':
            case 'telephone':
            case 'voorletter':
            case 'achternaam':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s darf nicht leer sein';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s ist ein Pflichtfeld';
                break;

            case 'opt-in':
                translation = 'Bitte klicken Sie die das Feld, um fortzufahren';
                break;

            default:
                translation = 'Dieses Feld wurde inkorrekt ausgefüllt';
                break;
        }

        return translation;
    }
}
